var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecorPinkTrianglee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 96,
    viewBox: "0 0 124 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1603_1451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.061 32.6507L169.915 91.0292L143.509 151.552L79.7282 168.642L26.5983 129.431L24.1296 63.4463L74.18 20.3733L139.061 32.6507Z",
    stroke: "#F9C6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.147 52.4584C64.8958 52.637 65.5571 51.9381 65.3375 51.2003L53.8895 12.7547C53.6699 12.0169 52.7339 11.7936 52.2048 12.3528L24.6339 41.4898C24.1048 42.0489 24.3794 42.9711 25.1282 43.1498L64.147 52.4584Z",
    fill: "#F9C6C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1603_1451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorPinkTrianglee);
export default __webpack_public_path__ + "static/media/decor-pink-trianglee.d42c1bed2bc1ce7c68cef567a8d2ed2c.svg";
export { ForwardRef as ReactComponent };